import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs, Table, Modal, ProgressBar, Accordion } from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { getDataAtual, formataDataHoraExibicao, tiposSessoesCampos } from '../../common/utils';
import { withRouter } from '../../common/with-router';
import logomarca from '../../assets/images/logo_cuidados_branco.png';
import logomarca2 from '../../assets/images/logo_ache_branco.png';

class Pesquisa extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);

        this.fileInput = React.createRef();

        this.state = {
            atendimento_uuid: "",
            motivos_optout: [],
            titulo_pagina: "Pesquisa",
            motivo_id: "",
            motivo_outros: "",
            mostrarCampoOutro: false,
            loading: false,
            erroLoadRegistro: "",
            programa: {},
            servicos_etapa: [],
            etapa_relato: {},
            camposFormulario: [],
            valoresCampos: {},
            valoresCamposExtra: {},
            valoresCamposExtraPaciente: {},
            botao_atual: {},
            camposOutro: {},
            erroLoadRegistro: '',
            uuid: '',
            beneficiario_id: '',
            atendente_id: '',
            data: '',
            programa_id: '',
            etapa_id: '',
            cliente_id: '',
            finalizado: '',
            cliente_nome: '',
            programa_nome: '',
            etapa_nome: '',
            medico_id: '',
            medico_atual_id: '',
            medico_nome: '',
            laboratorio_id: '',
            laboratorio_nome: '',
            etapa_atendimento_id: '',
            etapa_atendimento_status: '',
            etapa_atendimento_data_status: '',
            loading: false,
            tipo_paciente: '',
            programa_status_id: '',
            programa_status_slug: '',
            doenca_id: '',
            doenca_nome: '',
            pdf_termo_prestador: '',
            lets_sign_documento_id: '',
            lets_sign_documento_assinado_url: '',
            lets_sign_msg_erro: '',
            lets_doc_status: '',
            lets_assinatura_status: '',
            beneficiario_nome: '',
            beneficiario_celular: '',
            beneficiario_dados: {},
            atendente_nome: '',
            plano_nome: '',
            doenca_outros: '',
            dados_medico: {},
            dados_etapa: {},
            dados_formulario: {},
            proxima_acao: '',
            formulario_pesquisa_id: '',
            medico_data_alteracao: ''
        };
    }

    tratarNulos = (obj) => {
        const novoObjeto = {};
        for (let key in obj) {
            novoObjeto[key] = (obj[key] === null || obj[key] === "null") ? "" : obj[key];
        }
        return novoObjeto;
    };


    componentDidMount(){
        const uuid = this.props.router.params.id;
        const searchParams = new URLSearchParams(this.props.router.location.search);

        if(uuid){
            this.setState({
                atendimento_uuid: uuid,
                loading: true,
                erroLoadRegistro: ''
            })

            let config = {
                headers: {
                    'X-USERNAME': import.meta.env.VITE_X_USERNAME,
                }
            }
            
            //consulta os dados do atendimento na api
            api.get(`/atendimentos/${uuid}/`, config)
            .then(response => {
                const dadosResponse = response.data;
                const dados = this.tratarNulos(dadosResponse);
                
                //preenche os inputs
                this.setState({
                    erroLoadRegistro: '',
                    uuid: dados.uuid,
                    atendimento_id: dados.id,
                    beneficiario_id: dados.beneficiario_id,
                    atendente_id: dados.atendente_id ,
                    data: dados.data || '',
                    programa_id: dados.programa_id,
                    etapa_id: dados.etapa_id,
                    termo_paciente_pdf_comprovante: dados.termo_paciente_pdf_comprovante,
                    termo_prestador_pdf_comprovante: dados.termo_prestador_pdf_comprovante,
                    cliente_id: dados.cliente_id,
                    plano_id: dados.plano_id,
                    plano_nome: dados.dados_plano.nome,
                    doenca_id: dados.doenca_id,
                    doenca_nome: dados.dados_doenca.nome,
                    pdf_termo_prestador: dados.pdf_termo_prestador,
                    lets_sign_documento_id: dados.lets_sign_documento_id,
                    lets_sign_documento_assinado_url: dados.lets_sign_documento_assinado_url,
                    lets_sign_msg_erro: dados.lets_sign_msg_erro,
                    lets_doc_status: dados.lets_doc_status,
                    lets_assinatura_status: dados.lets_assinatura_status,
                    finalizado: dados.finalizado,
                    beneficiario_nome: dados.dados_beneficiario.nome,
                    beneficiario_celular: dados.dados_beneficiario.celular,
                    beneficiario_dados: dados.dados_beneficiario,
                    atendente_nome: dados.dados_atendente.nome,
                    cliente_nome: dados.dados_cliente.nome,
                    programa_nome: dados.dados_programa.nome,
                    etapa_nome: dados.dados_etapa.nome,
                    medico_id: dados.medico_id,
                    medico_atual_id: dados.medico_id,
                    medico_nome: dados.dados_medico.nome,
                    laboratorio_id: dados.laboratorio_id,
                    laboratorio_nome: dados.dados_laboratorio.nome_fantasia,
                    etapa_atendimento_id: (dados.dados_etapa_status && dados.dados_etapa_status.id) ? dados.dados_etapa_status.id : '',
                    etapa_atendimento_status: (dados.dados_etapa_status && dados.dados_etapa_status.status) ? dados.dados_etapa_status.status : '',
                    etapa_atendimento_data_status: (dados.dados_etapa_status && dados.dados_etapa_status.data_cadastro) ? dados.dados_etapa_status.data_cadastro : '',
                    cancelado: dados.cancelado,
                    camposExtraCadastrados: dados.extra_valores_list,
                    loading: false,
                    tipo_paciente: dados.tipo_paciente,
                    programa_status_id: dados.programa_status_id,
                    programa_status_slug: dados.dados_programa_status?.slug,
                    doenca_outros: dados.doenca_outros,
                    dados_medico: dados.dados_medico,
                    proxima_acao: dados.proxima_acao,
                    dados_etapa: dados.dados_etapa,
                    formulario_pesquisa_id: dados.dados_etapa.formulario_pesquisa_id,
                    medico_data_alteracao: dados.medico_data_alteracao,
                    dados_formulario: dados.dados_formulario_pesquisa

                }, () => {
                    
                    if(dados.dados_etapa.formulario_pesquisa_id){
                        this.carregaFormulario();
                    }
                })  
            })
            .catch(error => {

                let erro_msg = 'Erro ao consultar atendimento, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })

                //exibe a pagina 404
                //this.props.router.navigate("/404");
            });

        }
    }

    carregaFormulario = async () => {
        // Aqui fazemos a chamada para a API para buscar os campos do formulário
        let config = {
            headers: {
                'X-USERNAME': import.meta.env.VITE_X_USERNAME,
            }
        }
        console.log(this.state.formulario_pesquisa_id);
        const response = await api.get(`/formularios/campos/?formulario_id=${this.state.formulario_pesquisa_id}&status=1&limit=500`, config)
        .then(response => {
            console.log(response.data);
            // Atualizamos o estado com os campos recebidos
            this.setState({ camposFormulario: response.data.results });
        })
        .catch(error => {
            console.error('Erro ao carregar campos do formulário:', error);
        });
    }
    
    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };
    handleChangeCampo = (id, value) => {
        // Verifica se o valor é um evento (para campos de arquivo, por exemplo)
        const isEvent = value && value.target;

        let finalValue = value;

        // Se for um evento e um campo de arquivo, captura o arquivo; caso contrário, usa o valor diretamente
        if (isEvent && value.target.type === "file") {
            finalValue = value.target.files[0]; // Pode ser undefined se nenhum arquivo for selecionado
        }
        else if(isEvent && (value.target.type === "checkbox" || value.target.type === "radio")){
            finalValue = value.target.checked
        } 
        else if (isEvent) {
            finalValue = value.target.value;
        }
        
        this.setState(prevState => {
            const novosCamposOutro = { ...prevState.camposOutro };
    
            if (!isEvent || (isEvent && value.target.type != "file" && value.target.type != "checkbox" && value.target.type != "radio")) {
                if (finalValue.toLowerCase() === 'outro') {
                    // Se "Outro" foi selecionado, adicione ao estado
                    novosCamposOutro[id] = '';
                } else {
                    // Caso contrário, remova do estado
                    delete novosCamposOutro[id];
                }
            }

            return {
                valoresCampos: {
                    ...prevState.valoresCampos,
                    [id]: finalValue,
                },
                camposOutro: novosCamposOutro,
            };
        });
    };

    handleChangeOutro = (id, valor) => {
        this.setState(prevState => ({
            camposOutro: {
                ...prevState.camposOutro,
                [id]: valor,
            },
        }));
    };

    handleChangeCampoAtendExtra = (id, value) => {
        // Verifica se o valor é um evento (para campos de arquivo, por exemplo)
        const isEvent = value && value.target;

        let finalValue = value;

        // Se for um evento e um campo de arquivo, captura o arquivo; caso contrário, usa o valor diretamente
        if (isEvent && value.target.type === "file") {
            finalValue = value.target.files[0]; // Pode ser undefined se nenhum arquivo for selecionado
        }
        else if(isEvent && (value.target.type === "checkbox" || value.target.type === "radio")){
            finalValue = value.target.checked
        } 
        else if (isEvent) {
            finalValue = value.target.value;
        }

        // Atualiza o estado
        /*this.setState(prevState => ({
            valoresCamposExtra: {
                ...prevState.valoresCamposExtra,
                [id]: finalValue,
            },
        }));*/

        this.setState(prevState => {
            const novosCamposOutroExtra = { ...prevState.camposOutrosExtra };
    
            if (!isEvent || (isEvent && value.target.type != "file" && value.target.type != "checkbox" && value.target.type != "radio")) {
                if (finalValue.toLowerCase() === 'outro') {
                    // Se "Outro" foi selecionado, adicione ao estado
                    novosCamposOutroExtra[id] = '';
                } else {
                    // Caso contrário, remova do estado
                    delete novosCamposOutroExtra[id];
                }
            }

            return {
                valoresCamposExtra: {
                    ...prevState.valoresCamposExtra,
                    [id]: finalValue,
                },
                camposOutrosExtra: novosCamposOutroExtra,
            };
        });
    };

    handleChangeOutroExtra = (id, valor) => {
        this.setState(prevState => ({
            camposOutrosExtra: {
                ...prevState.camposOutrosExtra,
                [id]: valor,
            },
        }));
    };

    carregarProdutosPrograma = async (inputValue) => {
        if (this.state.showModalBotao) {
            const dados_usuario = getCurrentUser();
            const programa_id = this.state.programa_id;
            try {
                const response = await api.get(`/programas/produtos/?produto=${inputValue}&programa=${programa_id}&status=1`);
                
                // Extrair nomes únicos
                const nomesUnicos = Array.from(
                    new Set(
                        response.data.results.map(produto => produto.dados_produto.nome.split(' - ')[0]) // Pega apenas o nome antes do " - "
                    )
                );
    
                // Mapear para o formato esperado
                const opcoes = nomesUnicos.map(nome => ({
                    value: nome,
                    label: nome
                }));
    
                return opcoes;
            } catch (error) {
                console.error('Erro ao carregar produtos:', error);
                return [];
            }
        }
    };

    //Envio do formulário de relato da etapa (registrar etapa)
    handleSubmit = (e) => {
        e.preventDefault(); // Isso evita a recarga da página


        if(this.state.opcaoModalRelato == 'novo_relato'){
            //console.log("Envio relato 1 = ", this.state.opcaoModalRelato);
            this.continuarEnvioFormularioRelato();
        }
        else {
            //console.log("Envio relato 2 = ", this.state.opcaoModalRelato);
            this.enviarFormularioRelato();
        }        
    };

    enviarFormularioRelato = () => {
        Swal.fire({
            title: 'Responder Pesquisa?',
            text: "Deseja responder a pesquisa?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3cc172',
            cancelButtonColor: '#eb4961',
            confirmButtonText: 'Sim, responder!',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ finalizar_etapa: true }, () => {
                    this.continuarEnvioFormularioRelato();  // Continua o processo de envio após confirmação
                });                
            } else {
                this.setState({ finalizar_etapa: false });
                //this.continuarEnvioFormularioRelato();  // Continua o processo de envio após confirmação
            }
        });
    };

    continuarEnvioFormularioRelato = () => {
        // Primeiro, salvar o relato
        this.setState({loading:true})

        const dataHoraAtualFormatada = getDataAtual();
        const { etapa_relato, atendimento_id, valoresCampos, camposFormulario } = this.state;

        let formData = new FormData();
        formData.append('data', dataHoraAtualFormatada);
        formData.append("etapa_id", this.state.etapa_id)
        formData.append('atendimento_id', atendimento_id);
        formData.append('formulario_id', this.state.dados_etapa.formulario_pesquisa_id);
        formData.append('tipo', 'etapa');

        //servico
        if(this.state.relato_servico_procedimento_id){
            formData.append('servico_procedimento_id', this.state.relato_servico_procedimento_id);
        }

        if(this.state.relato_tipo_paciente){
            formData.append('tipo_paciente', this.state.relato_tipo_paciente);        
        }

        let cont = 1;
        let cancelar_voltar_etapa = false;

        Object.entries(valoresCampos).forEach(([campoId, valor]) => {
            const campo = camposFormulario.find(c => c.id === parseInt(campoId));

            if (campo && (campo.tipo === "voltar_etapa" || campo.tipo === "cancela_atendimento") && valor === true) {
                cancelar_voltar_etapa = true;
            }

            if (valor instanceof File) {
                formData.append(`valor_arquivo_${cont}`, valor);
            } 
            else if (valor instanceof Boolean) {
                formData.append(`valor_valor_${cont}`, valor ? true : false);
            }
            else {
                formData.append(`valor_valor_${cont}`, valor);
            }
            formData.append(`valor_formulario_campo_id_${cont}`, campoId);
            cont++;
        });

        if (cancelar_voltar_etapa) {
            this.setState({ opcaoModalRelato: 'altera_etapa' });
        }

        const indiceEtapaAtual = parseInt(this.state.dados_etapa.ordem);

        // Verificar se existe uma próxima etapa
        const proximaEtapa = indiceEtapaAtual + 1;
        
        let atendimento_finalizado = false;

        if(!proximaEtapa && this.state.finalizar_etapa === true) {
            atendimento_finalizado = true;
        }


        //verifica se etapa tem envio de mensagem no término da etapa
        let mensagem_inicial_enviada = false;

        //envia a requisição
        
        api({
            method: 'post',
            url: '/atendimentos/relatos/',
            data: formData,
            headers: {
                'X-USERNAME': import.meta.env.VITE_X_USERNAME,
            }
        })
        .then(response => {
            if(this.state.opcaoModalRelato == 'cadastrar_etapa' && atendimento_finalizado) {
                //sucesso
                this.setState({loading:false})
                Swal.fire({
                    title: 'Sucesso!',
                    text: 'Pesquisa respondida com sucesso.',
                    icon: 'success'
                }).then((result) => {
                    if (result.isConfirmed || result.dismiss) {
                        window.location.reload();
                    }
                });
            } 
            else if (this.state.opcaoModalRelato == 'cadastrar_etapa' && this.state.finalizar_etapa === true && atendimento_finalizado === false) {

                //Verifica se deve mandar mensageria pra etapa inicial
                if(!mensagem_inicial_enviada && proximaEtapa.midias_contato && proximaEtapa.momento_envio == 'inicio' && (proximaEtapa.tipo_envio == 'automatico' || proximaEtapa.tipo_envio == 'ambos')) {
                    
                    const dadosMensageria = {
                        etapa_id: proximaEtapa.id,
                        atendimento_id: this.state.atendimento_id
                    }

                    api({
                        method: 'post',
                        url: '/mensageria/etapa/',
                        data: dadosMensageria
                    })
                    .then(responseMensageriaEtapa => {
                        
                    })
                    .catch(error => {
                        console.log("Mensagem da etapa não enviada", error);
                    });
                }

                //sucesso
                this.setState({loading:false})
                Swal.fire({
                    title: 'Sucesso!',
                    text: 'Pesquisa respondida com sucesso.',
                    icon: 'success'
                }).then((result) => {
                    if (result.isConfirmed || result.dismiss) {
                        window.location.reload();
                    }
                });
            }
            else {
                this.setState({loading:false})
                Swal.fire({
                    title: 'Sucesso!',
                    text: 'Pesquisa respondida com sucesso.',
                    icon: 'success'
                }).then((result) => {
                    if (result.isConfirmed || result.dismiss) {
                        window.location.reload();
                    }
                });
            }
        })
        .catch(error => {
            this.setState({loading:false})
            console.error('Erro ao responder a pesquisa:', error);
            Swal.fire('Erro!', 'Não foi possível responder a pesquisa.', 'error');
            //Sentry.captureException('Erro ao salvar o relato:', error);
        });
    };

    handleShowModalRelatosEdit = () => {
        this.setState({ 
            etapa_relato: this.state.etapa_atual,             
        }, () => {
            this.setState({
                opcaoModalRelato: 'cadastrar_etapa',
                showModalRelatosEdit: true, 
                loading: true, 
                camposFormulario: []    
            });

            let config = {
                headers: {
                    'X-USERNAME': import.meta.env.VITE_X_USERNAME,
                }
            }

            // Aqui fazemos a chamada para a API para buscar os campos do formulário
            api.get(`/formularios/campos/?formulario_id=${this.state.formulario_id}&status=1&limit=500`, config)
            .then(response => {
                // Atualizamos o estado com os campos recebidos
                this.setState({ camposFormulario: response.data.results });
            })
            .catch(error => {
                console.error('Erro ao carregar campos do formulário:', error);
                Sentry.captureException('Erro ao carregar campos do formulário:', error);
            });

            //consultar os servicos relacionados a etapa
            this.setState({ servicos_etapa: [], relato_servico_procedimento_id: '', relato_servico_procedimento_nome: '' });
            if(this.state.etapa_atual.servicos_relacionados) {
                api.get(`/programas/etapas/servicos/?etapa_id=${this.state.etapa_relato.id}&prestador_id=${this.state.laboratorio_id}`)
                .then(response => {
                    // Atualizamos o estado com os campos recebidos
                    this.setState({ servicos_etapa: response.data.results, loading: false });
                })
                .catch(error => {
                    console.error('Erro ao carregar serviços da etapa:', error);
                    Sentry.captureException('Erro ao carregar serviços da etapa:', error);
    
                    this.setState({ loading: false });
                });
            } else {
                this.setState({ loading: false });
            }
        });        
    };

    carregaServicosEtapa = async () => {

        let opcoesFiltradas = []

        let count = 0
        this.state.servicos_etapa.forEach(servico => {
            if(servico.servico_procedimento_id > 0){
                count++;

                //primeiro servico
                if(this.state.etapa_relato.servico_fixo && count == 1){
                    this.setState({
                        relato_servico_procedimento_id: servico.servico_procedimento_id,
                        relato_servico_procedimento_nome: servico.dados_servico.nome
                    })
                }

                opcoesFiltradas.push({
                    value: servico.servico_procedimento_id,
                    label: servico.dados_servico.nome,
                })
            }
        });
    
        return opcoesFiltradas;
    };

    render(){
        if(this.state.loading) {
            return(
                <div className="container">
                    <Row className="mt-5 align-items-center justify-content-center">
                        <Col sm={8} lg={8}>
                            <h1 className="page-title text-center mb-5">Carregando Pesquisa</h1>
                        </Col>
                    </Row>
                </div>
            )
        }        
        return (
            <div className="container">
                <Row className="mt-2 align-items-center justify-content-center">
                    <Col sm={8} lg={8}>
                        <Row className="align-items-center mt-0 mb-5">
                            <Col sm={2}>
                                {this.state.dados_formulario.logo ? (
                                    <div className="text-center">
                                        <img src={this.state.dados_formulario.logo} alt={this.state.programa_nome} className="img-fluid" />
                                    </div>
                                ) : (
                                    <div className="text-center">
                                        <img src={logomarca} alt={this.state.programa_nome} className="img-fluid"  style={{maxHeight: "30px"}} />
                                    </div>
                                )}
                            </Col> 
                            <Col sm={8}>
                                <h1 className="page-title title-optout text-center mb-3 mt-3">{this.state.dados_formulario.nome}</h1>      
                            </Col> 
                            <Col sm={2}>
                                {this.state.dados_formulario.logo ? (
                                    <div className="text-center">
                                        <img src={this.state.dados_formulario.logo} alt={this.state.programa_nome} className="img-fluid" />
                                    </div>
                                ) : (
                                    <div className="text-center">
                                        <img src={logomarca2} alt={this.state.programa_nome} className="img-fluid" style={{maxHeight: "30px"}} />
                                    </div>
                                )}
                            </Col>                            
                        </Row>

                        <Card className="cardDestaque">     
                            <Card.Body className="p-4">
                                {this.state.camposFormulario.length > 0 && !this.state.dados_etapa.pesquisa_respondida  ? (
                                    <div>
                                        <Form onSubmit={this.handleSubmit}>
                                            <Row>
                                            {this.state.camposFormulario.map((campo, index) => {

                                                let shouldHide = false;

                                                // Verifica se o campo possui a propriedade 'mascara' e se inclui 'hide='
                                                if (campo.mascara && campo.mascara.includes('hide=')) {
                                                    // Extrai os valores após 'hide=' e divide por '|'
                                                    const hideValues = campo.mascara.split('hide=')[1].split('|');
                                                }

                                                // Verifica se o campo possui a propriedade 'mascara' e processa 'show-on[...]'
                                                if (campo.mascara && campo.mascara.includes('show-on[')) {
                                                    // Extrai o conteúdo entre 'show-on[' e ']'
                                                    const showOnCondition = campo.mascara.match(/show-on\[(.*?)\]/)?.[1];
                                                    if (showOnCondition) {
                                                        // Detecta operadores e separa os componentes da condição
                                                        const operatorMatch = showOnCondition.match(/(<=|>=|<|>|=)/);
                                                        if (operatorMatch) {
                                                            const operator = operatorMatch[0]; // O operador encontrado (<=, >=, <, >, =)
                                                            const [relatedSlug, expectedValue] = showOnCondition.split(operator); // Separa o slug e o valor esperado
                                                            const relatedField = this.state.camposFormulario.find((relatedCampo) => relatedCampo.slug === relatedSlug.trim());
                                                        
                                                            if (relatedField) {
                                                                const relatedValue = this.state.valoresCampos[relatedField.id] || ""; // Valor atual no estado
                                                                const expectedNumericValue = parseFloat(expectedValue.trim()); // Valor esperado (numérico)
                                                        
                                                                // Avalia a condição com base no operador
                                                                let conditionMet = false;
                                                                switch (operator) {
                                                                    case '<':
                                                                        conditionMet = parseFloat(relatedValue) < expectedNumericValue;
                                                                        break;
                                                                    case '>':
                                                                        conditionMet = parseFloat(relatedValue) > expectedNumericValue;
                                                                        break;
                                                                    case '<=':
                                                                        conditionMet = parseFloat(relatedValue) <= expectedNumericValue;
                                                                        break;
                                                                    case '>=':
                                                                        conditionMet = parseFloat(relatedValue) >= expectedNumericValue;
                                                                        break;
                                                                    case '=':
                                                                        conditionMet = relatedValue.toString() === expectedValue.trim(); // Comparação como string
                                                                        break;
                                                                    default:
                                                                        break;
                                                                }
                                                        
                                                                if (!conditionMet) {
                                                                    shouldHide = true; // Oculta o campo se a condição não for atendida
                                                                }
                                                            }
                                                        }
                                                    }
                                                }

                                                // Se o campo deve ser ocultado, retorna null para não renderizá-lo
                                                if (shouldHide) {
                                                    return null;
                                                }
                                                
                                                return (
                                                    <React.Fragment key={index}>
                                                        {campo.tipo === 'texto' || campo.tipo === 'numero' || campo.tipo === 'area_texto' || campo.tipo === 'data' || campo.tipo === 'selecao' ? (
                                                            <Col sm={12} className="mb-3">
                                                                <Form.Group>
                                                                    <Form.Label>{campo.nome}</Form.Label>
                                                                    {campo.tipo === 'selecao' ? (
                                                                        <Form.Control as="select" required={(campo.obrigatorio && this.state.opcaoModalRelato != 'novo_relato') ? true : false} onChange={(e) => this.handleChangeCampo(campo.id, e.target.value)}>
                                                                            <option value="">Selecione...</option>
                                                                            {campo.opcoes.split('\n').map((opcao, idx) => {
                                                                                const [valor, label] = opcao.split(':');
                                                                                return <option key={idx} value={valor}>{label}</option>;
                                                                            })}
                                                                        </Form.Control>
                                                                    ) : (
                                                                        <>
                                                                            {campo.tipo === 'texto' || campo.tipo === 'numero' || campo.tipo === 'data' ? (
                                                                                <Form.Control
                                                                                    type={campo.tipo === 'data' ? 'date' : campo.tipo === 'numero' ? 'number' : 'text'}
                                                                                    value={this.state.valoresCampos[campo.id] || ''}
                                                                                    required={(campo.obrigatorio && this.state.opcaoModalRelato != 'novo_relato') ? true : false}
                                                                                    onChange={(e) => this.handleChangeCampo(campo.id, e.target.value)}
                                                                                />
                                                                            ) : (
                                                                                <Form.Control
                                                                                    as={campo.tipo === 'data' ? 'date' : campo.tipo === 'area_texto' ? 'textarea' : 'text'}
                                                                                    value={this.state.valoresCampos[campo.id] || ''}
                                                                                    required={(campo.obrigatorio && this.state.opcaoModalRelato != 'novo_relato') ? true : false}
                                                                                    className={campo.tipo === 'data' ? '' : campo.tipo === 'area_texto' ? 'custom-textarea2' : ''}
                                                                                    onChange={(e) => this.handleChangeCampo(campo.id, e.target.value)}
                                                                                />
                                                                            )}
                                                                        </>
                                                                    )}
                                                                    {campo.descricao && <Form.Text className="text-muted" style={{fontSize: '0.9em'}}>{campo.descricao}</Form.Text>}
                                                                </Form.Group>
                                                            </Col>
                                                        ) : null}
                                                        {campo.tipo === 'arquivo' && (
                                                            <Col sm={6} className="mb-3">
                                                                <Form.Group>
                                                                    <Form.Label>{campo.nome}</Form.Label>
                                                                    <Form.Control 
                                                                        type="file" 
                                                                        required={(campo.obrigatorio && this.state.opcaoModalRelato != 'novo_relato') ? true : false}
                                                                        onChange={(e) => this.handleChangeCampo(campo.id, e)}
                                                                    />
                                                                    {campo.descricao && <Form.Text className="text-muted">{campo.descricao}</Form.Text>}
                                                                </Form.Group>
                                                            </Col>
                                                        )}
                                                        {(campo.tipo === 'cancela_atendimento' || campo.tipo == 'voltar_etapa') && (
                                                            <Col sm={6} className="mb-3">
                                                                <Form.Group>
                                                                    <Form.Check type="switch" 
                                                                        name={campo.tipo} 
                                                                        id={campo.tipo} 
                                                                        label={campo.nome}                                                             
                                                                        value="1" 
                                                                        required={(campo.obrigatorio && this.state.opcaoModalRelato != 'novo_relato') ? true : false}
                                                                        checked={this.state.valoresCampos[campo.id] ? true : false} 
                                                                        onChange={(e) => this.handleChangeCampo(campo.id, e)} 
                                                                    />
                                                                    {campo.descricao && <Form.Text className="text-muted">{campo.descricao}</Form.Text>}
                                                                </Form.Group>                                                    
                                                            </Col>
                                                        )}
                                                    </React.Fragment>
                                                );
                                            })}

                                            </Row>
                                            <Row>
                                                <Col sm={12}>
                                                    <Button variant="success" size="sm" type="submit" disabled={this.state.loading}>{this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Responder Pesquisa'}</Button>
                                                </Col>
                                            </Row>
                                        </Form>      
                                    </div>
                                ) : (
                                    <Col sm={12} className="mb-3">
                                        {this.state.dados_etapa.pesquisa_respondida ? (
                                            <Col sm={12} className="mb-3 mt-3 text-center">
                                                <h6>Pesquisa respondida em <span style={{fontWeight: 'bold'}}>{formataDataHoraExibicao(this.state.dados_etapa.data_pesquisa_respondida)}</span></h6>
                                            </Col>
                                        ) : (
                                            <Col sm={12} className="mb-3 mt-3 text-center">
                                                <h6>Pesquisa não encontrada!</h6>
                                            </Col>
                                        )}
                                    </Col>
                                )}  
                            </Card.Body>
                        </Card>

                        {this.state.programa_imagem_branca && (
                            <div className="mt-5 text-center">
                                <p>Powered by <a href="https://aditushealth.com.br" target="_blank"><img src={logomarca} alt="Aditus Health" style={{ maxWidth: '60px' }} /></a></p>
                            </div>
                        )}
                    </Col>
                </Row>
            </div>
        )
    }
}

export default withRouter(Pesquisa);